/**
 * Order Module Constants
 */

/**
 * CKYC journeys, each with its own on/off flag in the backend config.
 * VERIFY     -> redirect journey (POST /ckyc/member/verify)
 * UPLOAD_DOC -> document upload journey (POST /ckyc/member/upload-doc)
 */
export const KYC_FLOW_VERIFY = "VERIFY";
export const KYC_FLOW_UPLOAD_DOC = "UPLOAD_DOC";

// Presentation for each journey the backend can offer.
export const KYC_FLOW_META = {
  [KYC_FLOW_UPLOAD_DOC]: {
    title: "Upload Documents",
    subtitle: "Aadhaar, PAN photo uploads (JPG, PNG, PDF)",
    view: "doc-chooser",
  },
  [KYC_FLOW_VERIFY]: {
    title: "Verify with PAN/Aadhaar Number",
    subtitle: "Instant verification using ID numbers and redirect flow",
    view: "verify",
  },
};

export const CKYC_PROPOSAL_KEYS = {
  name: "name",
  gender: "gender",
  pan: "dn_pancardnumb",
  dob: "birth_date",
  panFile: "dn_pancard",
  aadhaarFile: "dn_aadhcard",
};

/**
 * Unique Query Key for CKYC Flows API
 */
export const CKYC_FLOWS_QUERY_KEY = ["ckycFlows"];
